// URL checks for CMS-supplied links that end up in a src or href.

/** Hosts a local backend serves its MinIO assets from over plain http. */
const LOOPBACK_HOSTS = ['localhost', '127.0.0.1', '[::1]'];

/**
 * An uploaded video's URL (a CloudFront-signed MP4), or null when it is not
 * safe to hand to a <video>: anything but an absolute https:// URL is refused
 * -- javascript:, data:, blob:, relative paths, protocol-relative "//host".
 * Plain http is let through for loopback hosts only, so a local backend's
 * MinIO assets still play in development; a production page would block that
 * as mixed content anyway.
 */
export function safeVideoUrl(raw: string | null | undefined): string | null {
  const value = (raw ?? '').trim();
  if (!value || /\s/.test(value)) { return null; }
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return null;
  }
  if (url.protocol === 'https:') { return value; }
  if (url.protocol === 'http:' && LOOPBACK_HOSTS.includes(url.hostname)) { return value; }
  return null;
}

/**
 * A news link's publisher URL, or null unless it is an absolute https:// URL
 * (the CMS stores nothing else; this is the same rule applied again before it
 * becomes an href).
 */
export function safeExternalUrl(raw: string | null | undefined): string | null {
  const value = (raw ?? '').trim();
  if (!value || /\s/.test(value)) { return null; }
  try {
    return new URL(value).protocol === 'https:' ? value : null;
  } catch {
    return null;
  }
}

/**
 * What a news-link card names as its source when the CMS gave no publisher
 * name: the URL's host without "www." ("timesofindia.indiatimes.com").
 */
export function hostLabel(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./i, '');
  } catch {
    return '';
  }
}
